import DefaultModal from '../../../../components/Modal/DefaultModal';
import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import ProtocolService from '../../service';
import { toast } from 'react-toastify';
import { Row, Form, Col, Button } from 'reactstrap';
import StatusService from '../../../status/service';
import FlexSelect from '../../../../components/Inputs/FlexSelect';
import { validateFields } from '../../form/assets/functions';

const ModalStatus = ({
  isModalOpen,
  onModalToggle,
  idProtocol,
  idStatusProtocol,
  recordTypeId,
  isRequired,
  render,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const [statusList, setStatusList] = useState([]);
  const { control, handleSubmit, errors, setValue, reset } = useForm();

  useEffect(() => {
    if (idStatusProtocol && idProtocol) {
      StatusService.get(idStatusProtocol)
        .then((response) => {
          const res = response.data.content;
          reset(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [idStatusProtocol, reset, idProtocol]);

  useEffect(() => {
    StatusService.getByRecordType(recordTypeId)
      .then((response) => {
        const res = response.data.content;
        setStatusList(res);
      })
      .catch((err) => {
        const message =
          (err.response && err.response.data) || 'Erro ao carregar status/fase';
        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
        closeModal();
      });
  }, [closeModal]);

  const onSubmit = async (data) => {
    try {
      let message;
      await ProtocolService.protocolUpdateData(
        idProtocol,
        data,
        'change_status'
      );

      message = 'Status/Fase do protocolo atualizado com sucesso';
      toast.success(message, {
        autoClose: 3000,
        closeOnClick: true
      });

      render(statusList.find((item) => item.id === data.status_id));
      closeModal();
    } catch (err) {
      toast.error(' Erro ao atualizar o protocolo', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Alterar status/fase do Protocolo"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Status/Fase*</label>
              <Controller
                render={(props) => (
                  <FlexSelect
                    isClearable={true}
                    dataOptions={statusList}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    value={props.value}
                    valueController={setValue}
                    fieldName="status_id"
                    labelName="name"
                    valueName="id"
                  />
                )}
                control={control}
                name="status_id"
                rules={validateFields(isRequired)}
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="status_id"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>
          <hr />
          <Button color="primary" type="submit">
            Salvar
          </Button>
          <Button color="danger" onClick={closeModal}>
            Voltar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};

export default ModalStatus;
